import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const loginEmail = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data?.needs_2fa) {
      // Don't set user yet — 2FA still required. Caller will continue with loginEmail2fa.
      return { needs_2fa: true, challenge_id: r.data.challenge_id };
    }
    setUser(r.data.user);
    return r.data.user;
  };
  const loginEmail2fa = async (challenge_id, code) => {
    const r = await api.post("/auth/login/2fa", { challenge_id, code });
    setUser(r.data.user);
    return r.data.user;
  };
  const registerEmail = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, loginEmail, loginEmail2fa, registerEmail, logout, setUser, refreshUser: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
